module.exports = __webpack_public_path__ + "assets/icons/dt-icon-developer.svg";